import { componentsTranslationKeys, dispatchSnackbarNegativeEvent, RouteLeavingGuard } from '@dreryk/react-components';
import { useDraftCreateCqrsCommand } from '@dreryk/react-draft';

import { DocumentTemplateFormController } from '~libs.desktop.shared.document-template';

import { visitTranslationKeys } from '../../translations';
import { getConsentTemplateDraftTag, getVisitDraftTag } from '../../visit/visit.draft';

import { getConsentTemplateDraftToken } from './consentTemplate.draft';
import { translationKeys } from './translations';

type ConsentTemplateFormLeavingGuardProps = Pick<DocumentTemplateFormController, 'handleSubmitDraft' | 'formState'> & {
   readonly visitId: number;
   readonly printTemplateId: number;
};

export const ConsentTemplateFormLeavingGuard = (props: ConsentTemplateFormLeavingGuardProps): JSX.Element => {
   const { executeAsync: saveDocumentTemplateDraft } = useDraftCreateCqrsCommand({
      onUnexpectedError: () => {
         dispatchSnackbarNegativeEvent(visitTranslationKeys.draftSaveFail);
      },
   });

   const handleLeave = props.handleSubmitDraft(async (formData) =>
      saveDocumentTemplateDraft({
         token: getConsentTemplateDraftToken(props.visitId, props.printTemplateId),
         tags: [getVisitDraftTag(props.visitId), getConsentTemplateDraftTag(props.visitId)],
         contents: formData,
      })
   );

   return (
      <RouteLeavingGuard
         testId={'formLeavingConfirmation'}
         title={componentsTranslationKeys.leaveForm}
         message={componentsTranslationKeys.formLeavingConfirmation}
         successMessage={translationKeys.leavingGuard.successMessage}
         onLeave={handleLeave}
         active={props.formState.isDirty}
      />
   );
};
